import {
  PartialTheme,
  IDropdownProps,
  ILabelProps,
  ISearchBoxProps,
  IStyle,
  ITextFieldProps,
  ITheme,
} from '@fluentui/react';

const filterStyleBasic: IStyle = {
  display: 'flex',
  alignItems: 'stretch',
  border: 'none',
  background: 'none',
  lineHeight: 'normal',
};

const Label: ILabelProps = {
  styles: {
    root: { ...filterStyleBasic, width: 'fit-content' },
  },
};

const SearchBox: ISearchBoxProps = {
  styles: {
    root: filterStyleBasic,
  },
};

const Dropdown: Partial<IDropdownProps> = {
  styles: {
    root: {
      ...filterStyleBasic,
      width: '100%',
    },
    dropdown: {
      width: '100%',
      display: 'flex',
      alignContent: 'stretch',
    },
    caretDownWrapper: {
      display: 'flex',
      alignContent: 'center',
    },
    title: {
      ...filterStyleBasic,
      minWidth: 0,
      height: '1.3em',
      width: '100%',
      display: 'block',
      verticalAlign: 'middle',
      textAlign: 'center',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      marginTop: 'auto',
      marginBottom: 'auto',
      paddingRight: '1.5em',
    },
  },
};

const TextField: ITextFieldProps = {
  styles: {
    root: filterStyleBasic,
    wrapper: filterStyleBasic,
    fieldGroup: filterStyleBasic,
    description: filterStyleBasic,
    field: filterStyleBasic,
  },
};

/** Theme customizations specific to subdued filter UI */
export const filterCustomizations: PartialTheme = {
  components: {
    Label,
    // DatePicker: DatePicker(theme),
    Dropdown,
    SearchBox,
    TextField,
  },
};
